// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"9600c558","338":"9bb23890","564":"edf9344f","656":"523b8cd6","679":"3c71c159","857":"604fdedc"}[chunkId] + ".chunk.js";
};